<template>
    <div class="planbord-grid-container" :style="{gridTemplateColumns, '--left-non-day-columns': informationColumns, '--right-non-day-columns': hourBalanceColumns}">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class PlanbordGridContainer extends Vue {
        @Prop({type: Number, required: true}) public informationColumns!: number;
        @Prop({type: Number, required: true}) public dayColumns!: number;
        @Prop({type: Number, required: true}) public hourBalanceColumns!: number;
        @Prop({type: Boolean}) public compact!: boolean;

        public get informationColumnMinWidth(): number {
            return this.compact ? 8 : 10;
        }

        public get dayColumnMinWidth(): number {
            return this.compact ? 3 : 6;
        }

        public get hourBalanceColumnMinWidth(): number {
            return this.compact ? 3 : 7.5;
        }

        public get gridTemplateColumns(): string {
            const gridTemplateParts: string[] = [];

            if (this.informationColumns > 0) {
                gridTemplateParts.push(`repeat(${this.informationColumns}, minmax(${this.informationColumnMinWidth}rem, 1fr))`);
            }

            if (this.dayColumns > 0) {
                gridTemplateParts.push(`repeat(${this.dayColumns}, minmax(${this.dayColumnMinWidth}rem, 1fr))`);
            }

            if (this.hourBalanceColumns > 0) {
                gridTemplateParts.push(`repeat(${this.hourBalanceColumns}, minmax(${this.hourBalanceColumnMinWidth}rem, 1fr))`);
            }

            return gridTemplateParts.join(' ');
        }
    }
</script>

<style lang="scss" scoped>
    .planbord-grid-container {
        padding: 0 1rem;
        display: inline-grid; // grid can't grow -- inline-grid can (and a grown grid has better position: sticky handling).
        min-width: 100%;
    }
</style>
